export const opacityToHex = (opacity: number) =>
  Math.round(opacity * 255)
    .toString(16)
    .padStart(2, '0');

export const hexColorOpacity = (hexColor: string, opacity = 1) => hexColor.concat(opacityToHex(opacity));
